import { compile } from 'path-to-regexp'


const cache = {}

const getLinkWithParams = (link, params, encode = false) => {
  if (!cache[link]) {
    cache[link] = compile(link, {
      encode: encode ? encodeURIComponent : undefined,
    })
  }

  return cache[link](params)
}


export default getLinkWithParams
